const state = {
  documents: [],
  requestForm: {}
};

export default {
  state
};
